module.exports = __webpack_public_path__ + "static/media/20ECE5.d92f76ea.jpg";